import React, { useEffect } from 'react';
import { useTranslate } from '@pegasus/translation';
import { trackSelectContent, trackViewContent } from '@browsing/tracking';
import { MessagePurpose, MessageType } from '@lux/message';

import { StyledBanner } from './styles';

interface SecurityBannerProps {
    handleVisibilityOnClick: () => void;
    userEmail: string;
}

export const SecurityBanner: React.FC<SecurityBannerProps> = ({
    handleVisibilityOnClick,
    userEmail,
}) => {
    useEffect(() => {
        trackViewContent('compromised_password_banner');
    }, []);

    const onCloseBanner = () => {
        trackSelectContent('compromised_password_banner', 'close');

        handleVisibilityOnClick();
    };

    const onLinkClick = () => {
        trackSelectContent('compromised_password_banner', 'click');

        handleVisibilityOnClick();
        const uspHint = new URLSearchParams(`login_hint=${window.btoa(userEmail)}`);

        window.location.assign(
            `/sso/login?view=forgot-password&login_hint=${uspHint.get(
                'login_hint',
            )}&target=/event?compromisedbanner`,
        );
    };

    const translate = useTranslate('securityBanner');

    return (
        <StyledBanner
            type={MessageType.BANNER}
            linkText={translate('linkText')}
            onClose={onCloseBanner}
            purpose={MessagePurpose.COMMERCIAL}
            onLinkClick={onLinkClick}
        >
            {translate('text')}
        </StyledBanner>
    );
};
